import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import { FilterMatchMode } from 'primereact/api';
import { errorMessage, NormalMessage, successMessage } from "../../utils/alertMessage";
import { formatDate } from "../../constants/FormateDate";
import { Dialog } from "primereact/dialog";
import { getLead, getLeadSource, getLeadStatusApi, getLeadSummary, getLeadType, userLeadAssign } from "../../services/leads";
import { LeadListUpload } from "../../services/bankListUpload";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../utils/localStorage";
import { replaceUnderscoresWithSpacesAndUpperCase } from "../../components/Regex";
import { getProduct, getStateWiseCities, getUser } from "../../services/userMasterUser";
import { Calendar } from "primereact/calendar";
import { DataScroller } from 'primereact/datascroller';
import { Button } from "primereact/button";
import { MCubeCall } from "../../services/MCubeCall";

export default function LeadList() {

  const [products, setProducts] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState(null);

  const navigate = useNavigate();

  const { userProfileData } = getUserData();

  let dataLimitValue = localStorage.getItem("dataLimit") || 500;

  const location = useLocation();

  const ds = useRef(null);

  const isFirstRender = useRef(true);

  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(dataLimitValue);
  const [loadingMore, setLoadingMore] = useState(false);

  const [fileName, setFileName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [displayLeadListUpload, setDisplayLeadListUpload] = useState(false);

  const [displayLeadAssignmentUpload, setDisplayLeadAssignmentUpload] = useState(false);
  const [assignedTelecallerId, setAssignedTelecallerId] = useState("")
  const [assignedLeadId, setAssignedLeadId] = useState("")
  const [leadSourceUploadValue, setLeadSourceUploadValue] = useState("");

  const [pagesBoxField, setPagesBoxField] = useState(0);
  const [selectedType, setSelectedType] = useState("");


  const onClickLeadListUpload = (item) => {
    setDisplayLeadListUpload(true);
  };
  const onHideLeadListUpload = () => {
    setFileName("");
    setSelectedImage(null);
    setDisplayLeadListUpload(false);
  };

  const onClickLeadAssignmentUpload = (item) => {
    setAssignedLeadId(item)
    setDisplayLeadAssignmentUpload(true);
  };
  const onHideLeadAssignmentUpload = () => {

    setAssignedTelecallerId("");
    setDisplayLeadAssignmentUpload(false);
  };

  const [startDate, setStartDate] = useState(new Date(localStorage.getItem("startDateFilter")));
  const [endDate, setEndDate] = useState(new Date(localStorage.getItem("endDateFilter")));
  const [leadSourceList, setLeadSourceList] = useState([])
  const [boxFieldData1, setBoxFieldData1] = useState([])
  const [boxFieldData2, setBoxFieldData2] = useState([])
  const [boxFieldData3, setBoxFieldData3] = useState([])
  const [boxFieldData4, setBoxFieldData4] = useState([])
  const [userDataIds, setUserDataIds] = useState([]);

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getLead(data)
      // getUserLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;
          setProducts(rawData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };


  const UnassignedLeadsPayload = {
    statusIn: [
      "RECEIVE",
    ],
    recordType: "CreatedOn",
    startDate: startDate,
    endDate: endDate,
    leadTypeIn: [
      "Loan",
      "loan_type_lead",
    ],
    sortBy: "",
    sortOrder: "desc",
    userIdIn: [],
    minAmount: 0,
    maxAmount: 0
  };

  const RetailUnassignedPayload = {
    statusIn: [
      "RECEIVE"
    ],
    recordType: "CreatedOn",
    startDate: startDate,
    endDate: endDate,
    leadTypeIn: [
      "Loan",
      "loan_type_lead",
    ],
    sortBy: "",
    sortOrder: "desc",
    userIdIn: [],
    minAmount: 0,
    maxAmount: 10000000
  };

  const WholesaleUnassignedPayload = {
    statusIn: [
      "RECEIVE"
    ],
    recordType: "CreatedOn",
    startDate: startDate,
    endDate: endDate,
    leadTypeIn: [
      "Loan",
      "loan_type_lead",
    ],
    sortBy: "",
    sortOrder: "desc",
    userIdIn: [],
    minAmount: 10000000,
    maxAmount: 0
  };

  const OthersPayload = {
    statusIn: [
      "RECEIVE"
    ],
    recordType: "CreatedOn",
    startDate: startDate,
    endDate: endDate,
    leadTypeIn: [
      "project_report_tev_study_pitch_deck",
      "course",
      "software",
      "subsidy",
      "nivesh4u",
      "cfo_msme",
      "CFOMSME",
      "business_partner",
      "",
    ],
    sortBy: "",
    sortOrder: "desc",
    userIdIn: [],
    minAmount: 0,
    maxAmount: 0,
    typeOfLeadCheck: "blankAlso"
  };

  const [defaultPayload, setDefaultPayload] = useState({})

  const fetchUnassignedLeadsData = (typeDataBoxField, type) => {
    setLoadingMore(true);

    getLeadSummary(typeDataBoxField)
      // getUserLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          if (type === "type1") {
            const totalRawData = rawData.reduce((sum, item) => sum + (item?.count || 0), 0);
            setBoxFieldData1(totalRawData)
          }
          if (type === "type2") {
            const totalRawData = rawData.reduce((sum, item) => sum + (item?.count || 0), 0);
            setBoxFieldData2(totalRawData)
          }
          if (type === "type3") {
            const totalRawData = rawData.reduce((sum, item) => sum + (item?.count || 0), 0);
            setBoxFieldData3(totalRawData)
          }
          if (type === "type4") {
            const totalRawData = rawData.reduce((sum, item) => sum + (item?.count || 0), 0);
            setBoxFieldData4(totalRawData)
          }
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  const userData = {
    searchBy: "",
    searchText: "",
    limit: 1000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    userTypeIdIn: [],
    roleIn: ["ROLE_TELECALLER", "ROLE_OPERATION"],
    statusIn: ["ACTIVE"]

  };

  const getUsers = (userData) => {
    getUser(userData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const newDataId = newData.map(item => item.id);
          const newDataIds = newData.map(item => ({
            label: item.userName + " - " + item?.userTypeInfo, value: item.id
          }));

          setUserDataIds(newDataIds)
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  }

  useEffect(() => {


    fetchUnassignedLeadsData(UnassignedLeadsPayload, "type1");
    fetchUnassignedLeadsData(RetailUnassignedPayload, "type2");
    fetchUnassignedLeadsData(WholesaleUnassignedPayload, "type3");
    fetchUnassignedLeadsData(OthersPayload, "type4");


    getUsers(userData)

    if (location.state?.listState) {
      const { products, first, rows, selectedType, pagesBoxField } = location.state.listState;
      setProducts(products);
      setFirst(first);
      setRows(rows);
      setSelectedType(selectedType)
      setPagesBoxField(pagesBoxField)
    } else {
      // fetchData({
      //   ...typeData,
      //   limit: rows,
      //   offset: 0
      // });
    }
    getLeadSource()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const leadSource = Res.map((item) => ({
            label: item,
            value: item,
          }));


          setLeadSourceList(leadSource)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));
  }, []);

 
  const handleReceiveData = (type, totalCount, payload) => {
    setSelectedType(type)
    setPagesBoxField(0);
    setDefaultPayload(payload)
    let pages = Math.ceil(totalCount / dataLimitValue);

    setPagesBoxField(pages);
    if (pages > 0) {
      handlePageChange(0, payload)
    }
  };

  const handlePageChange = (pageNumber, defaultPayload) => {
    const newOffset = pageNumber * rows;

    fetchData(
      {
        ...defaultPayload,
        limit: rows,
        offset: newOffset
      },
      true // append mode
    );

    setFirst(newOffset);
  };

  const handleLeadListUpload = (event) => {
    event.preventDefault();
    const fileInput = event.target.querySelector('input[type="file"]');
    const uploadFile = fileInput.files[0];
    const leadSourceUpload = leadSourceUploadValue

    if (!uploadFile) {
      console.error("No file selected");
      return;
    }

    LeadListUpload(uploadFile, leadSourceUpload)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage("Lead List Upload Successfully " + Res.message);
          setFileName("");
          setSelectedImage(null);
          setDisplayLeadListUpload(false);
        } else {
          errorMessage("Lead List Upload Failed " + Res.message);
          setFileName("");
          setSelectedImage(null);
          setDisplayLeadListUpload(false);
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Lead List Upload Failed");
        setFileName("");
        setSelectedImage(null);
        setDisplayLeadListUpload(false);
      });
  };

  const handleLeadAssignmentUpload = (event) => {

    event.preventDefault();

    const leadAssignedData = {
      lead: {
        id: assignedLeadId?.lead?.id,
        status: "ASSIGN"
      },
      user: {
        id: assignedTelecallerId
      }
    }

    userLeadAssign(leadAssignedData)
      .then((response) => {
        const Res = response.data;
        // handle the response
        if (Res.status === true) {
          successMessage("Lead Assigned Successfully " + Res.message);
          setAssignedTelecallerId("")
          setAssignedLeadId("")
          setProducts(products);
          setFirst(first);
          setRows(rows);

          setDisplayLeadAssignmentUpload(false);
        } else {
          errorMessage("Lead Assigned Failed " + Res.message);
          setAssignedTelecallerId("")
          setAssignedLeadId("")
          setProducts(products);
          setFirst(first);
          setRows(rows);

          setDisplayLeadAssignmentUpload(false);
        }
      })
      .catch((error) => {
        // handle errors
        errorMessage("Lead Assigned Failed");
        setAssignedTelecallerId("")
        setAssignedLeadId("")
        setProducts(products);
        setFirst(first);
        setRows(rows);

        setDisplayLeadAssignmentUpload(false);
      });
  };

  const handleLeadListDownload = () => {
    const link = document.createElement("a");
    link.href = "/bulk_Lead_upload.xlsx"; // File path inside public folder
    link.download = "bulk_Lead_upload.xlsx"; // Rename file on download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setFileName(file ? file.name : ""); // Update the file name or clear it if no file is selected

    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    } else {
      setSelectedImage(null);
    }
  };

  const renderDialogLeadUpload = () => (
    <Dialog
      header="Lead List Upload"
      visible={displayLeadListUpload}
      onHide={() => onHideLeadListUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleLeadListUpload}>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                onClick={handleLeadListDownload}
                style={{
                  padding: "10px",
                  background: "blue",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Download Sample File
              </button>
            </div>
            <div className="col-md-12 mt-3">

              <Dropdown
                style={{ width: "100%" }}
                value={leadSourceUploadValue}
                onChange={(e) => setLeadSourceUploadValue(e.value)}
                options={leadSourceList}
                optionLabel="label"
                placeholder="Select Lead Source"
              />
            </div>
          </div>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <label for="file-upload" className="custom-file-upload">
                  <i className="pi pi-upload"></i> Choose Lead List File
                </label>
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div>
              <div>
                <i
                  className="pi pi-file"
                  style={{ color: "blue", fontSize: "40px" }}
                ></i>
                {fileName && (
                  <p
                    style={{
                      alignSelf: "center",
                      fontSize: 14,
                      fontWeight: 600,
                      margin: 10,
                    }}
                  >
                    {fileName}
                  </p>
                )}
              </div>
            </div>
          </div>
          {selectedImage && (
            <div className="col-md-12 text-center">
              <button
                type="submit"
                className="move-btn move-btn-blue"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );

  const renderDialogLeadAssignmentUpload = () => (
    <Dialog
      header="Lead Assignment"
      visible={displayLeadAssignmentUpload}
      onHide={() => onHideLeadAssignmentUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleLeadAssignmentUpload}>
          <div className="row mb-3">
            <h6> {assignedLeadId?.lead?.name} Lead Assigned To </h6>
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >

              <div className="col-md mb-2">
                <Dropdown
                  style={{ width: "100%" }}
                  options={userDataIds}
                  value={assignedTelecallerId}
                  onChange={(e) => {
                    setAssignedTelecallerId(e.value);
                  }}
                />
              </div>
            </div>
          </div>
          {assignedTelecallerId && (
            <div className="col-md-12 text-center">
              <button
                type="submit"
                className="move-btn move-btn-blue"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );

  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }

  

  const handleMcubeCall = (selectedItem) => {

    const data = {
      httpAuthorization: userProfileData?.mcubeAuthToken,
      exeNumber: userProfileData?.mobile,
      custNumber: selectedItem?.lead?.mobileNo
    }

    if (userProfileData?.mcubeAuthToken && userProfileData?.mobile && selectedItem?.lead?.mobileNo) {
      MCubeCall(data)
        .then((response) => {
          const Res = response.data;
          // handle the response
          NormalMessage(Res.msg);
        })
        .catch((error) => {
          // handle errors
          errorMessage("Failed");
        });
    } else {
      errorMessage(
        [
          !userProfileData?.mcubeAuthToken && "Mcube Auth Token Is Not Present",
          !userProfileData?.mobile && "User Mobile Number Is Not Present",
          !selectedItem?.lead?.mobileNo && "Customer Mobile Is Not Present",
        ]
          .filter(Boolean)
          .join("<br/>")
      );
    }
  }

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">


                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <div >
                    <h5 className="card-title flex">
                      <div
                        className="mr-3 cursor-pointer"
                        onClick={() => navigate("/")}
                      >
                        <i class="bi bi-arrow-left-circle-fill"></i>
                      </div> Lead Box
                    </h5>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignSelf: "center" }}>
                    <div style={{ alignSelf: "center" }}>
                      {userProfileData.role === "ROLE_OPERATION" ?
                        <Link
                          to="/lead-form-operation-team-create"
                          className="move-btn move-btn-blue center-text"
                        >
                          Create
                        </Link>
                        :
                        <Link
                          to="/lead-form-create"
                          className="move-btn move-btn-blue center-text"
                        >
                          Create
                        </Link>}
                    </div>
                    <div style={{ alignSelf: "center" }}>

                      {userProfileData.role !== "ROLE_TELECALLER" && <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 20,
                          marginRight: 10,
                          marginLeft: 10,
                        }}
                      >
                        <i
                          onClick={() =>
                            onClickLeadListUpload(
                              "displayLeadListUpload"
                            )
                          }
                          className="pi pi-upload"
                          style={{
                            fontSize: "20px",
                            color: "#1e439b",
                            cursor: "pointer",
                          }}
                        ></i>

                      </div>}
                    </div>
                  </div>
                </div>

                <div className="kpi-row">
                  <div className="kpi"
                    style={{
                      borderLeftColor: '#1A4DB5',
                      cursor: "pointer",
                      outline: selectedType === 'type1'
                        ? "2px solid #1A4DB5"
                        : "none",
                      opacity: selectedType && selectedType !== 'type1' ? 0.45 : 1,
                      transition: "opacity 0.2s, outline 0.2s",
                    }}
                    onClick={() => handleReceiveData("type1", boxFieldData1, UnassignedLeadsPayload)}>
                    <div className="kpi-lbl">Unassigned Leads</div>
                    <div className="kpi-val">{boxFieldData1}</div>
                    <div className="kpi-sub">Only RECEIVE status</div>
                  </div>

                  <div className="kpi"
                    style={{
                      borderLeftColor: '#16A869',
                      cursor: "pointer",
                      outline: selectedType === 'type2'
                        ? "2px solid #16A869"
                        : "none",
                      opacity: selectedType && selectedType !== 'type2' ? 0.45 : 1,
                      transition: "opacity 0.2s, outline 0.2s",
                    }} onClick={() => handleReceiveData("type2", boxFieldData2, RetailUnassignedPayload)}>
                    <div className="kpi-lbl">Retail Unassigned</div>
                    <div className="kpi-val">{boxFieldData2}</div>
                    <div className="kpi-sub">Up to ₹1Cr</div>
                  </div>

                  <div className="kpi" style={{
                    borderLeftColor: '#0B9EAA',
                    cursor: "pointer",
                    outline: selectedType === 'type3'
                      ? "2px solid #0B9EAA"
                      : "none",
                    opacity: selectedType && selectedType !== 'type3' ? 0.45 : 1,
                    transition: "opacity 0.2s, outline 0.2s",
                  }} onClick={() => handleReceiveData("type3", boxFieldData3, WholesaleUnassignedPayload)}>
                    <div className="kpi-lbl">Wholesale Unassigned</div>
                    <div className="kpi-val">{boxFieldData3}</div>
                    <div className="kpi-sub">Above ₹1Cr</div>
                  </div>

                  <div className="kpi" style={{
                    borderLeftColor: '#E87010',
                    cursor: "pointer",
                    outline: selectedType === 'type4'
                      ? "2px solid #E87010"
                      : "none",
                    opacity: selectedType && selectedType !== 'type4' ? 0.45 : 1,
                    transition: "opacity 0.2s, outline 0.2s",
                  }} onClick={() => handleReceiveData("type4", boxFieldData4, OthersPayload)}>
                    <div className="kpi-lbl">Others</div>
                    <div className="kpi-val">
                      {boxFieldData4}
                    </div>
                    <div className="kpi-sub">Other than Loan lead</div>
                  </div>

                </div>
                <div className="dataview-demo">
                  <div className="card leadList">
                    {pagesBoxField > 0 && <DataTable
                      value={products}
                      // lazy
                      dataKey="lead.id"
                      scrollable
                      scrollHeight="400px"
                      // paginator
                      first={first}   // ✅ THIS FIXES YOUR ISSUE
                      onPage={(e) => setFirst(e.first)} // ✅ also required
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      // rows={rows}
                      // rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      globalFilterFields={['id', 'createdDate', 'name', "mobile", "city", "state"]}
                      stripedRows
                    >

                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>

                      <Column
                        field="View"
                        header="Action"
                        className="product-category table-design"
                        body={(rowData) => (
                          <div className="action-cell">

                            <Link
                              title="Edit or View"
                              to="/lead-form-create"
                              state={{
                                rowData,
                                listState: {
                                  products,
                                  first,
                                  rows,
                                  selectedType,
                                  pagesBoxField
                                }
                              }}
                              className="act-btn act-view"
                            ><i className="pi pi-pencil"></i>
                            </Link>

                            <div
                              title="Direct Call From Your Mobile Number"
                              className="act-btn act-call"
                              onClick={() => {
                                window.location.href = `tel:${rowData?.lead?.mobileNo}`;
                              }}
                            >
                              <i className="pi pi-phone"></i>
                            </div>

                            <a
                              title="Whatsapp"
                              href={`https://wa.me/91${rowData?.lead?.mobileNo}?text=${encodeURIComponent(
                                `Hello ${rowData?.lead?.name}, thank you for your interest.`
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="act-btn act-whatsapp"
                            >
                              <i className="pi pi-whatsapp"></i>
                            </a>

                            <div
                              title="Lead Assignment"
                              onClick={() =>
                                onClickLeadAssignmentUpload(
                                  rowData
                                )
                              }
                              className="act-btn act-rec"
                            >
                              <i className="bi bi-fast-forward-btn-fill"></i>
                            </div>

                            <Link
                              title="Lead Working Status"
                              to={"/user-lead-info"}
                              state={{
                                rowData,
                                listState: {
                                  products,
                                  first,
                                  rows,
                                  selectedType,
                                  pagesBoxField
                                }
                              }}
                              className="act-btn act-edit"
                            >
                              <i className="bi bi-eye"></i>
                            </Link>

                            <div
                              title="Pabbly Lead"
                              className={
                                rowData?.lead?.pabblyResponseMessageId
                                  ? "act-btn act-whatsapp"
                                  : "act-btn act-red"
                              }
                            >
                              {rowData?.lead?.pabblyResponseMessageId ? (
                                <i className="pi pi-check"></i>
                              ) : (
                                <i className="pi pi-times"></i>
                              )}
                            </div>

                            <div
                              title="MCube Call"
                              className="act-btn act-call"
                              onClick={() => handleMcubeCall(rowData)}
                            >
                              <i className="bi bi-telephone-outbound-fill"></i>
                            </div>
                          </div>
                        )}
                      ></Column>
                      <Column
                        field="status"
                        header="Status"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => {
                          const statusText = rowData.lead?.status === "RECEIVE"
                            ? "New Lead"
                            : rowData.lead?.status;
                          return (
                            <span
                              className="colored_with_bg1"
                            >
                              {statusText}
                            </span>
                          );
                        }}
                      ></Column>
                      <Column
                        field="dateOfLead"
                        header="Date Of Lead"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored3">
                            {formatDate(rowData.lead?.dateOfLead)}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="name"
                        header="Name"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored2">
                            {rowData?.lead?.name}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="mobileNo"
                        header="Mobile No"
                        style={{ minWidth: '120px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored4">
                            {rowData.lead?.mobileNo}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="typeOfLead"
                        header="Type Of Lead"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored_with_bg2">
                            {rowData?.lead?.typeOfLead ? replaceUnderscoresWithSpacesAndUpperCase(rowData?.lead?.typeOfLead) : ""}

                          </span>
                        )}
                      ></Column>

                      <Column
                        field="amount"
                        header="Amount"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored1">
                            {rowData.lead?.amount?.toLocaleString("en-IN")}
                          </span>
                        )}
                      ></Column>
                      {/*<Column
                        field="preferredLanguage"
                        header="Preferred Language"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.preferredLanguage}
                          </span>
                        )}
                      ></Column>*/}

                      <Column
                        field="productInfo"
                        header="Product Info"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored6">
                            {rowData.lead?.productInfo}
                          </span>
                        )}
                      ></Column>


                      <Column
                        field="queries"
                        header="Remarks"
                        style={{ minWidth: '200px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored6">
                            {rowData.lead?.queries}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="queries"
                        header="Telecaller Remarks"
                        style={{ minWidth: '200px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.leadInfoList
                              ?.find((item) => item.keyName === "remarkByTelecaller")
                              ?.textValue || ""}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="address"
                        header="Address"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.address}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="source"
                        header="Source"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span className="colored7">
                            {rowData.lead?.source}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="followUpOn"
                        header="Follow Up On"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => {
                          const followUpDate = rowData?.leadInfoList?.find(
                            item => item.keyName === "nextFollowUpDate"
                          )?.dateValue;

                          return (
                            <span>
                              {followUpDate ? formatDate(followUpDate) : "N/A"}
                            </span>
                          );
                        }
                        }
                      ></Column>



                      {/*<Column
                        field="sales"
                        header="Sales"
                        style={{ minWidth: '100px' }}
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.leadInfoList
                              ?.find((item) => item.keyName === "sales")
                              ?.textValue || ""}
                          </span>
                        )}
                      ></Column>*/}

                      {(userProfileData.role === "ROLE_TELECALLER" || userProfileData.role === "ROLE_SUPER_TELECALLER") &&
                        <Column
                          field="Doc"
                          header="Doc View"
                          className="product-category table-design"
                          body={(rowData) => (
                            <Link
                              to={"/view-lead-document"}
                              state={rowData?.lead}
                              className="move-btn-medium move-btn-green center-text"
                            >
                              Doc View <i className="bi bi-eye"></i>
                            </Link>
                          )}
                        ></Column>}

                    </DataTable>}

                    <div className="flex justify-content-center gap-2 my-3">
                      {Array.from({ length: pagesBoxField }).map((_, index) => (
                        <Button
                          key={index}
                          label={(index + 1).toString()}
                          onClick={() => handlePageChange(index, defaultPayload)}
                          className={rows === index ? "p-button" : "p-button-outlined"}
                        />
                      ))}
                    </div>
                  </div>
                  <DataScroller
                    ref={ds}
                    value={products}
                    itemTemplate={itemTemplate}
                    rows={5}
                    loader
                  />


                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div>{renderDialogLeadUpload()}</div>
      <div>{renderDialogLeadAssignmentUpload()}</div>
    </main>
  );
}
